<div class="recent-search-item" [ngClass]="{ selected: selected, keyboardOn: keyboardOn }" (click)="clicked.emit(model)">
  <u-icon [styles]="{ 'font-size': '16px' }" class="magnifier" [model]="{ type: 'font', value: 'icon-clock' }"></u-icon>
  <tag-list
    *ngIf="model.tags?.length"
    #tagList
    [model]="model.tags"
    tabindex="-1"
    class="tag-container"
    [class.empty]="model.tags?.length === 0"
    [removable]="false"
  ></tag-list>
  <button class="query">
    {{ model.query }}
  </button>
</div>
